import * as React from 'react'
import { COUNTRY_SHORTCODES } from '../../../constants'
import { USA } from './Countries'
import * as DA from '../../../typeModules/events'

export type HandleChange<T extends HTMLElement> = (
  event: React.ChangeEvent<T>
) => void

export type Stripe = {
  createToken: (
    cardElement: string,
    data: object
  ) => Promise<{
    error: string
    token: string
  }>
}

type AddBankAccountProps = {
  country: keyof typeof COUNTRY_SHORTCODES
  stripe?: Stripe
  handleSecondaryAction?: HandleChange<HTMLInputElement>
  onSuccess?: <T>(t?: T) => void
  track?: <T>(...args: (DA.EventActions | T | object)[]) => Promise<void>
}

export const AddBankAccount: React.FC<AddBankAccountProps> = ({
  country,
  stripe,
  handleSecondaryAction,
  onSuccess,
  track,
}) => {
  switch (country) {
    case COUNTRY_SHORTCODES.US:
      return (
        <USA
          stripe={stripe}
          handleSecondaryAction={handleSecondaryAction}
          onSuccess={onSuccess}
          track={track}
        />
      )
    default:
      return (
        <USA
          stripe={stripe}
          handleSecondaryAction={handleSecondaryAction}
          onSuccess={onSuccess}
          track={track}
        />
      )
  }
}

export default AddBankAccount
